import { cn } from '@/lib/utils';
import { TableCell, TableHead } from './table';

const headBase = 'sticky left-0 z-20 w-12 bg-surface text-right tabular-nums';
const cellBase =
  'sticky left-0 z-10 w-12 bg-surface text-right tabular-nums text-secondary group-hover:bg-hover group-focus-within:bg-hover group-data-[state=selected]:bg-brand-50';

/**
 * Leading serial-number ("#") header cell for the shared <Table> primitive.
 */
export function TableIndexHead({ className }: { className?: string }) {
  return (
    <TableHead scope="col" aria-label="Serial number" className={cn(headBase, className)}>
      #
    </TableHead>
  );
}

/**
 * Leading serial-number ("#") cell for a shared <Table> row. The parent
 * <TableRow> must carry the `group` class for hover/selected backgrounds.
 */
export function TableIndexCell({ value, className }: { value: number; className?: string }) {
  return <TableCell className={cn(cellBase, className)}>{value}</TableCell>;
}

/**
 * Leading serial-number ("#") header cell for a raw <table>.
 */
export function RawTableIndexHead({ className }: { className?: string }) {
  return (
    <th
      scope="col"
      aria-label="Serial number"
      className={cn('sticky left-0 z-20 w-12 bg-surface py-3 text-right font-medium tabular-nums', className)}
    >
      #
    </th>
  );
}

/**
 * Leading serial-number ("#") cell for a raw <table> row. The parent <tr>
 * must carry the `group` class for hover backgrounds.
 */
export function RawTableIndexCell({ value, className }: { value: number; className?: string }) {
  return (
    <td
      className={cn(
        'sticky left-0 z-10 w-12 bg-surface py-3 text-right tabular-nums text-secondary group-hover:bg-hover group-focus-within:bg-hover',
        className
      )}
    >
      {value}
    </td>
  );
}
